import { createApp } from 'vue';
import App from '@/App.vue';
import router from '@/router';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import { library } from '@fortawesome/fontawesome-svg-core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'; // Add this import
import {
  faArrowLeft,
  faCopy,
  faEdit,
  faMinusCircle,
  faFilePdf,
  faPlusCircle,
  faSearch,
  faSignOutAlt,
  faSortDown,
  faSortUp,
  faUpload,
  faDownload,
  faSave,
  faTrash,
  faSync,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import '@/lib/interceptors';
import { MailOutlined } from '@ant-design/icons-vue';
import Notifications from '@kyvg/vue3-notification';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// Add FontAwesome icons
library.add(
  faArrowLeft as IconDefinition,
  faCopy as IconDefinition,
  faEdit as IconDefinition,
  faMinusCircle as IconDefinition,
  faFilePdf as IconDefinition,
  faPlusCircle as IconDefinition,
  faSearch as IconDefinition,
  faSignOutAlt as IconDefinition,
  faSortDown as IconDefinition,
  faSortUp as IconDefinition,
  faUpload as IconDefinition,
  faDownload as IconDefinition,
  faSave as IconDefinition,
  faTrash as IconDefinition,
  faSync as IconDefinition,
  faSpinner as IconDefinition,
);


createApp(App).component('font-awesome-icon', FontAwesomeIcon).use(router).use(Antd).use(Notifications).component('MailOutlined', MailOutlined).mount('#app');
